import styled from 'styled-components';

import { TranslateFunction, useTranslate } from '@dreryk/react-common';
import { basicBodyTextStyle, basicSmallTextStyle, fonts } from '@dreryk/react-components';

import { guardiansTranslationKeys, personalDataTranslationKeys } from '../../../translations';
import { GuardianDetailsFormBean } from '../GuardianDetailsModal/GuardianDetailsModal';

type PatientSearchItemProps = {
   readonly patient: GuardianDetailsFormBean;
};

const nameFormatter = (patient: GuardianDetailsFormBean): string => {
   return `${patient.lastName ?? ''} ${patient.firstName ?? ''}`.trim();
};

const detailsFormatter = (guardian: GuardianDetailsFormBean, translate: TranslateFunction): string => {
   let result = '';
   if (guardian.guardianExternalIdentifierValue) {
      result += `${translate(
         personalDataTranslationKeys.identifierType.displayName[guardian.guardianExternalIdentifierType]
      )}: ${guardian.guardianExternalIdentifierValue}`;
   }

   if (result && guardian.phoneNumber) {
      result += ', ';
   }

   if (guardian.phoneNumber) {
      result += `${translate(guardiansTranslationKeys.phoneAbbreviation)} ${guardian.phoneNumber.asString()}`;
   }
   return result;
};

const StyledPatientName = styled.div`
   ${basicBodyTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;
StyledPatientName.displayName = 'StyledPatientName';

const StyledPatientDetails = styled.div`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.border};
`;
StyledPatientDetails.displayName = 'StyledPatientDetails';

export const PatientAutosuggestItem = (props: PatientSearchItemProps): JSX.Element => {
   const translate = useTranslate();
   const { patient } = props;

   return (
      <div>
         <StyledPatientName>{nameFormatter(patient)}</StyledPatientName>
         <StyledPatientDetails>{detailsFormatter(patient, translate)}</StyledPatientDetails>
      </div>
   );
};
